/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  FetchImageFromURLForm2,
  FetchImageFromURLForm2$Outbound,
  FetchImageFromURLForm2$outboundSchema,
} from "../components/fetchimagefromurlform2.js";

export type FetchImageFromURLSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type FetchImageFromURLSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type FetchImageFromURLSecurity = {
  option1?: FetchImageFromURLSecurityOption1 | undefined;
  option2?: FetchImageFromURLSecurityOption2 | undefined;
};

export type FetchImageFromURLRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  fetchImageFromURLForm2: FetchImageFromURLForm2;
};

/** @internal */
export type FetchImageFromURLSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const FetchImageFromURLSecurityOption1$outboundSchema: z.ZodMiniType<
  FetchImageFromURLSecurityOption1$Outbound,
  FetchImageFromURLSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function fetchImageFromURLSecurityOption1ToJSON(
  fetchImageFromURLSecurityOption1: FetchImageFromURLSecurityOption1,
): string {
  return JSON.stringify(
    FetchImageFromURLSecurityOption1$outboundSchema.parse(
      fetchImageFromURLSecurityOption1,
    ),
  );
}

/** @internal */
export type FetchImageFromURLSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const FetchImageFromURLSecurityOption2$outboundSchema: z.ZodMiniType<
  FetchImageFromURLSecurityOption2$Outbound,
  FetchImageFromURLSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function fetchImageFromURLSecurityOption2ToJSON(
  fetchImageFromURLSecurityOption2: FetchImageFromURLSecurityOption2,
): string {
  return JSON.stringify(
    FetchImageFromURLSecurityOption2$outboundSchema.parse(
      fetchImageFromURLSecurityOption2,
    ),
  );
}

/** @internal */
export type FetchImageFromURLSecurity$Outbound = {
  Option1?: FetchImageFromURLSecurityOption1$Outbound | undefined;
  Option2?: FetchImageFromURLSecurityOption2$Outbound | undefined;
};

/** @internal */
export const FetchImageFromURLSecurity$outboundSchema: z.ZodMiniType<
  FetchImageFromURLSecurity$Outbound,
  FetchImageFromURLSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => FetchImageFromURLSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => FetchImageFromURLSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function fetchImageFromURLSecurityToJSON(
  fetchImageFromURLSecurity: FetchImageFromURLSecurity,
): string {
  return JSON.stringify(
    FetchImageFromURLSecurity$outboundSchema.parse(fetchImageFromURLSecurity),
  );
}

/** @internal */
export type FetchImageFromURLRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  FetchImageFromURLForm2: FetchImageFromURLForm2$Outbound;
};

/** @internal */
export const FetchImageFromURLRequest$outboundSchema: z.ZodMiniType<
  FetchImageFromURLRequest$Outbound,
  FetchImageFromURLRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    fetchImageFromURLForm2: FetchImageFromURLForm2$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      fetchImageFromURLForm2: "FetchImageFromURLForm2",
    });
  }),
);

export function fetchImageFromURLRequestToJSON(
  fetchImageFromURLRequest: FetchImageFromURLRequest,
): string {
  return JSON.stringify(
    FetchImageFromURLRequest$outboundSchema.parse(fetchImageFromURLRequest),
  );
}
